import { createSelector } from 'reselect';
// import { MessagesByMedium, MessagesMetaDataByMedium, Message } from './types';

export const getScheduledMessages = (state) => state.messages.scheduled;
export const isDataFetching = (state) => state.messages.scheduled.isFetching;

/**
 *
 */
export const getScheduledMessagesByMedium = createSelector(getScheduledMessages, (schdMsgs) =>
  Object.entries(schdMsgs.byMedium).reduce((acc /*: MessagesMetaDataByMedium */, [key, val]) => {
    acc[key] = {
      label: key,
      messages: val,
      numMessages: val.length,
    };
    return acc;
  }, {}),
);

export const selectAllMessages = createSelector(getScheduledMessages, (schdMsgs) =>
  Object.values(schdMsgs.byMedium).reduce((acc /*: Message[] */, messages /*: Message[] */) => {
    if (messages.length) {
      acc.push(...messages);
    }
    return acc;
  }, []),
);
